import React from 'react';
import PropTypes from 'prop-types';

/**
 * DSSkeleton — Design System skeleton loader
 *
 * Wraps the CSS `.skeleton` class with a convenient count prop.
 *
 * Usage:
 * <DSSkeleton style={{ height: '40px', width: '300px', borderRadius: 'var(--radius-md)' }} />
 * <DSSkeleton count={3} style={{ height: '20px', marginBottom: 'var(--space-2)' }} />
 */
export function DSSkeleton({ count = 1, style, className = '' }) {
  if (count === 1) {
    return <div className={`skeleton ${className}`} style={style} />;
  }

  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={`skeleton ${className}`} style={style} />
      ))}
    </>
  );
}

DSSkeleton.propTypes = {
  count: PropTypes.number,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default DSSkeleton;
